import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { handleOutsideClick } from "../../../../Helpers/HandleOutsideClick";

const ScheduleInterviewModal = ({
  show,
  onClose,
  selectedInterview,
  interviewDateTime,
  setInterviewDateTime,
  remark,
  setRemark,
  loading,
  onSchedule,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(show);

  useEffect(() => {
    document.body.style.overflow = show ? "hidden" : "auto";

    if (show) {
      setShouldRender(true);
      setTimeout(() => setIsVisible(true), 10);
    } else {
      setIsVisible(false);
      setTimeout(() => setShouldRender(false), 500);
    }

    return () => (document.body.style.overflow = "auto");
  }, [show]);

  if (!shouldRender) return null;

  return (
    <div
      className={`fixed inset-0 z-[60] flex justify-end transition-opacity duration-500
      ${isVisible ? "bg-black/40 opacity-100" : "bg-black/0 opacity-0"}`}
      onClick={(e) => handleOutsideClick(e, onClose)}
    >
      {/* Drawer */}
      <div
        onClick={(e) => e.stopPropagation()}
        className={`
          bg-white h-full w-[40%] min-w-[420px]
          shadow-[ -10px_0px_30px_rgba(0,0,0,0.15) ]
          flex flex-col
          transform transition-transform duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]
          ${isVisible ? "translate-x-0" : "translate-x-full"}
        `}
      >
        {/* HEADER */}
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h5 className="text-lg font-semibold">
            {selectedInterview?.isInterviewCompleted === "2"
              ? "Reschedule Interview"
              : "Schedule Interview"}
          </h5>

          <button onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        {/* BODY */}
        <div className="flex-1 overflow-y-auto p-6">
          <div className="shadow-sm border rounded p-4 bg-gray-50">

            <h5 className="text-primary font-semibold uppercase text-sm mb-3">
              Interview Details
            </h5>

            <hr className="mb-4" />

            <h6 className="font-semibold mb-3 text-sm flex items-center">
              <span className="text-yellow-500 mr-2">⚠</span>
              Do you want to schedule interview for this candidate?
            </h6>

            {/* Date Time */}
            <input
              type="datetime-local"
              className="w-full border rounded px-3 py-2 text-sm"
              value={interviewDateTime}
              min={new Date().toISOString().slice(0, 16)}
              onChange={(e) => setInterviewDateTime(e.target.value)}
            />

            {/* Remark */}
            <textarea
              placeholder="Enter remark..."
              className="w-full border rounded px-3 py-2 text-sm mt-3 resize-none"
              style={{ minHeight: "90px" }}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />

            {/* Buttons */}
            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={onSchedule}
                disabled={loading}
                className="px-4 py-2 text-sm rounded-full bg-primary text-white shadow-sm disabled:opacity-50"
              >
                {loading ? "Processing..." : "Schedule Interview"}
              </button>

              <button
                onClick={onClose}
                className="px-4 py-2 text-sm rounded-full border hover:bg-gray-100"
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleInterviewModal;